import { Component, OnInit } from '@angular/core';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { CreatorLibraryService, TrashItem } from '../../../services/creator-library.service';
import { relativeTime } from '../../../pages/creator/creator-library';

interface TrashRow extends TrashItem {
  kindLabel: string;
  deletedText: string;
}

/**
 * Creator › Bibliothek › Papierkorb: content deleted in the last 30 days that
 * this person may restore (its creator, or admin/manager/super_admin —
 * the server decides, `GET /creator/items/trash`).
 */
@Component({
  selector: 'app-creator-trash-dialog',
  templateUrl: './creator-trash-dialog.component.html',
  styleUrl: './creator-trash-dialog.component.scss',
})
export class CreatorTrashDialogComponent implements OnInit {
  onRestored: () => void = () => undefined;

  rows: TrashRow[] | null = null;
  restoring: string | null = null;

  constructor(
    private ref: NbDialogRef<CreatorTrashDialogComponent>,
    private library: CreatorLibraryService,
    private toastr: NbToastrService,
    private t: TranslateService,
  ) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.library.trash().subscribe({
      next: (items) => {
        const now = Date.now();
        const lang = this.t.currentLang || 'de';
        this.rows = items.map((item) => {
          const key = `pages.creator.kinds.${item.kind}`;
          const kindLabel = this.t.instant(key);
          const when = relativeTime(item.deletedAt, now, lang);
          return {
            ...item,
            kindLabel: kindLabel === key ? item.kind : kindLabel,
            deletedText: item.deletedBy ? `${when} · ${item.deletedBy.name}` : when,
          };
        });
      },
      error: () => {
        this.rows = [];
        this.toastr.danger(this.t.instant('pages.creator.trash.loadFailed'), '');
      },
    });
  }

  restore(row: TrashRow): void {
    if (this.restoring) return;
    this.restoring = row.id;
    this.library.undelete(row.id).subscribe({
      next: () => {
        this.restoring = null;
        this.rows = (this.rows ?? []).filter((r) => r.id !== row.id);
        this.toastr.success(this.t.instant('pages.creator.trash.restored', { title: row.title }), '');
        this.onRestored();
      },
      error: () => {
        this.restoring = null;
        this.toastr.danger(this.t.instant('pages.creator.trash.restoreFailed'), '');
      },
    });
  }

  close(): void {
    this.ref.close();
  }
}
